import PropTypes from 'prop-types'

// TODO: Ask "Roman Semko", if the 'error' prop type definition is correct!

export const formChildPropTypes = Object.freeze({
    bindTo: PropTypes.func,
    error: PropTypes.shape({
        fieldName: PropTypes.string,
        message: PropTypes.string,
        reasons: PropTypes.arrayOf(
            PropTypes.shape({
                fieldName: PropTypes.string,
                message: PropTypes.string
            })
        )
    }),
    model: PropTypes.object,
    onModelChange: PropTypes.func,
    partialFormIndex: PropTypes.number // Can't be shaped in general, because every model is different.
})
